export enum SkillStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Recommended = 'RECOMMENDED',
  NonApplicable = 'NON_APPLICABLE',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE',
}
